import FormAnimation from '../../../../../FE/src/assets/javascripts/components/FormAnimation';
import SelectC8 from '../../../../../FE/src/assets/javascripts/components/SelectC8';

export default class ContactForm {
  constructor(el) {
    this.$this = $(el);
    this.$form = this.$this.find('.contact-form__form');
    this.$header = $('header.header');
    this.$htmlBody = $('html, body');

    this.offsetSpace = 50;

    // Initialize global SelectC8 instance
    this.globalSelectC8 = new SelectC8();

    // Selectors for select-c8 functionality
    this.selectors = {
      selectC8: '.select-c8',
      dropdownSelectC8: '.dropdown-select-c8',
      selectContainer: '.gfield--type-select .ginput_container_select',
      formSelectC8: '.form-select-c8',
      dropdownToggle: '.dropdown-toggle',
      dropdownMenu: '.dropdown-menu-c8',
      dropdownListItem: 'li.optiton-select',
      filterOption: '.filter-option',
      errorField: '.gfield_error',
      validationMessage: '.validation_message',
      gfield: '.gfield',
      errorFields: '.gfield_error input, .gfield_error textarea, .gfield_error select',
      captchaField: '.gfield--type-captcha',
      recaptchaContainer: '.ginput_recaptcha'
    };

    // Classes for select-c8 functionality
    this.classes = {
      selectC8: 'select-c8',
      selectDone: 'select-done',
      formSelectC8: 'form-select-c8',
      selected: 'selected',
      gfieldError: 'gfield_error',
      gfieldTypeEmail: 'gfield--type-email',
      gfieldTypePhone: 'gfield--type-phone',
      ginputPhone: 'ginput_phone',
      gfieldTypeCaptcha: 'gfield--type-captcha'
    };

    // Input types for validation
    this.inputTypes = {
      email: 'email',
      tel: 'tel'
    };

    // Timing configurations
    this.timings = {
      formCheck: 100,
      selectC8Ready: 200,
      autoSelectDelay: 500,
      focusDelay: 100
    };

    if (!this.$form.length) { return; }
  }

  init() {
    this.bindGravityFormsEvents();
    this.waitForGravityForm();
    this.initFormAnimation();
    this.setupRecaptchaCallback();
  }

  bindGravityFormsEvents() {
    $(document).on('gform_post_render', (event, formId) => {
      const $form = this.getFormElement(formId);

      if (!this.isInContactForm($form)) {
        return;
      }

      // Re-initialize form animation after form re-render
      this.initFormAnimation();

      setTimeout(() => {
        this.initSelectC8();
        this.handleValidationClear();
        this.handleRecaptchaValidation();
        // Restart reCAPTCHA polling after form re-render
        this.restartRecaptchaPolling();
        // this.waitForSelectC8AndAutoSelect($form);
        this.focusFirstErrorField(formId);
      }, this.timings.formCheck);
    });
  }

  waitForGravityForm() {
    if (this.$this.find('.gform_wrapper').length > 0) {
      this.initSelectC8();
    } else {
      setTimeout(() => {
        this.waitForGravityForm();
      }, this.timings.formCheck);
    }
  }

  focusFirstErrorField(formId) {
    const $form = this.getFormElement(formId);

    if (!$form.length || !$form.find('.gfield_error').length) {
      return;
    }

    const $firstErrorField = $form.find('.gfield_error').first();
    const $firstErrorFieldInput = $firstErrorField.find('input, textarea, select').first();
    const headerHeight = this.$header.outerHeight() || 0;

    this.$htmlBody.animate({
      scrollTop: $firstErrorField.offset().top - headerHeight - this.offsetSpace
    }, 500);

    if ($firstErrorFieldInput.length) {
      setTimeout(() => $firstErrorFieldInput.focus(), this.timings.focusDelay);
    }
  }

  handleValidationClear() {
    const errorFields = this.$this.find(this.selectors.errorFields);

    errorFields.each((_i, field) => {
      const $field = $(field);
      const $gfield = $field.closest(this.selectors.gfield);
      const validationText = $gfield.find(this.selectors.validationMessage).text().toLowerCase();
      const isRequiredError = validationText.includes('required');

      $field.off('input.validation change.validation blur.validation');

      const validateAndClear = () => {
        const fieldValue = $field.val();
        const isValid = this.validateField($field, fieldValue, isRequiredError);

        if (isValid) {
          this.clearFieldError($gfield, $field);
        }
      };

      $field.on('input.validation change.validation blur.validation', validateAndClear);
    });
  }

  validateField($field, value, isRequiredError) {
    const trimmedValue = value ? value.trim() : '';

    if (isRequiredError) {
      return trimmedValue !== '';
    }

    if (!trimmedValue) {
      return false;
    }

    const $gfield = $field.closest(this.selectors.gfield);
    const fieldType = $field.attr('type');
    const isEmailField = fieldType === this.inputTypes.email ||
      $gfield.hasClass(this.classes.gfieldTypeEmail);
    const isPhoneField = fieldType === this.inputTypes.tel ||
      $field.hasClass(this.classes.ginputPhone) ||
      $gfield.hasClass(this.classes.gfieldTypePhone);

    if (isEmailField) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedValue);
    }

    if (isPhoneField) {
      return trimmedValue.length >= 10;
    }

    return true;
  }

  clearFieldError($gfield, $field) {
    $gfield.removeClass(this.classes.gfieldError);
    $gfield.find(this.selectors.validationMessage).remove();
    $field.removeClass(this.classes.gfieldError);
    $field.attr('aria-invalid', 'false');
    $field.removeAttr('aria-describedby');
  }

  initFormAnimation() {
    new FormAnimation(this.$form);
  }

  initSelectC8() {
    this.$this.find(this.selectors.selectContainer).each((_i, container) => {
      const $container = $(container);
      const $select = $container.find('select');

      if (!$select.length) {
        return;
      }

      // Clean up existing select-c8 elements
      $container.find(this.selectors.dropdownSelectC8).remove();
      $select.removeClass(`${this.classes.selectC8} ${this.classes.selectDone}`);
      $container.removeClass(this.classes.formSelectC8);

      // Add select-c8 classes
      $select.addClass(this.classes.selectC8);
      $container.addClass(this.classes.formSelectC8);
    });

    // Set up global SelectC8 instance
    this.globalSelectC8.$callSelectC8 = $(this.selectors.selectC8);

    const needsInit = $(this.selectors.selectC8).length > 0 &&
      $(this.selectors.dropdownSelectC8).length === 0;

    if (needsInit) {
      this.globalSelectC8.init();
    } else {
      this.globalSelectC8.renderSelectToDropdown();
    }
  }

  getFormElement(formId) {
    return $(`#gform_${formId}`);
  }

  isInContactForm($element) {
    return $element.closest('.mod-contact-form').length > 0;
  }

  setupRecaptchaCallback() {
    // Wait for grecaptcha to be available
    const waitForGrecaptcha = () => {
      if (typeof grecaptcha !== 'undefined') {
        this.startRecaptchaPolling();
      } else {
        setTimeout(waitForGrecaptcha, 500);
      }
    };

    waitForGrecaptcha();
  }

  restartRecaptchaPolling() {
    // Stop existing polling intervals
    if (this.recaptchaPollInterval) {
      clearInterval(this.recaptchaPollInterval);
      this.recaptchaPollInterval = null;
    }
    if (this.recaptchaCheckInterval) {
      clearInterval(this.recaptchaCheckInterval);
      this.recaptchaCheckInterval = null;
    }
    // Start new polling
    this.startRecaptchaPolling();
  }

  startRecaptchaPolling() {
    let attempts = 0;
    const maxAttempts = 50; // 5 seconds max

    this.recaptchaCheckInterval = setInterval(() => {
      attempts++;
      const $recaptchaContainer = this.$this.find(this.selectors.recaptchaContainer);

      if ($recaptchaContainer.length) {
        const widgetId = $recaptchaContainer.attr('data-widget-id');

        if (widgetId !== undefined && widgetId !== '') {
          clearInterval(this.recaptchaCheckInterval);
          this.recaptchaCheckInterval = null;
          this.pollRecaptchaResponse(parseInt(widgetId));
        }
      }

      if (attempts >= maxAttempts) {
        clearInterval(this.recaptchaCheckInterval);
        this.recaptchaCheckInterval = null;
      }
    }, 100);
  }

  pollRecaptchaResponse(widgetId) {
    let lastResponse = '';
    let errorCount = 0;
    const maxErrors = 5;

    this.recaptchaPollInterval = setInterval(() => {
      if (typeof grecaptcha !== 'undefined') {
        try {
          const response = grecaptcha.getResponse(widgetId);

          // Reset error count on success
          errorCount = 0;

          if (response && response !== lastResponse) {
            lastResponse = response;
            this.handleRecaptchaValidation();
          }
        } catch (e) {
          errorCount++;

          // Stop polling if widget has been removed (form re-rendered)
          if (e.message.includes('removed') && errorCount >= maxErrors) {
            clearInterval(this.recaptchaPollInterval);
            this.recaptchaPollInterval = null;
          }
        }
      }
    }, 500);
  }

  handleRecaptchaValidation() {
    const $captchaFields = this.$this.find(`${this.selectors.captchaField}${this.selectors.errorField}`);

    $captchaFields.each((_i, field) => {
      const $gfield = $(field);
      const $recaptchaContainer = $gfield.find(this.selectors.recaptchaContainer);

      if ($recaptchaContainer.length) {
        const widgetId = $recaptchaContainer.attr('data-widget-id');

        // Check if recaptcha has been completed
        if (typeof grecaptcha !== 'undefined' && widgetId !== undefined) {
          try {
            const response = grecaptcha.getResponse(parseInt(widgetId));

            if (response) {
              $gfield.removeClass(this.classes.gfieldError);
              $gfield.find(this.selectors.validationMessage).remove();
            }
          } catch (e) {
            // Error checking reCAPTCHA
          }
        }
      }
    });
  }
}

$('.mod-contact-form').each((_index, el) => new ContactForm(el).init());
